import { Component, Input, inject } from '@angular/core';
import { ModalRef } from '@eg/ui';

@Component({
  selector: 'rmb-security-question',
  templateUrl: './security-question.component.html',
  styleUrl: './security-question.component.scss',
  standalone: false,
})
export class SecurityQuestionComponent {
  private modalRef = inject(ModalRef);

  @Input() source: string;
  @Input() prefix: string;

  onCloseClick(): void {
    this.modalRef.close();
  }

  onResponseClick(response: string): void {
    this.modalRef.close(response);
  }
}
